import { Button, Flex, Header, Loader, Tabs } from '@components';
import { useUserQuery } from '@features/api/userSlice';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMatch, useNavigate } from 'react-router-dom';
import { Container, StyledHeaderContainer } from './Crm.styles';
import NomineeCustomers from '@pages/NomineeCustomers/NomineeCustomers';
import NomineeInvestmentAttributions from '@pages/NomineeInvestmentAttributions/NomineeInvestmentAttributions';
import { NewInvestmentPanel } from '@components/NewInvestmentPanel/NewInvestmentPanel';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';

const Crm = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { sm: isMobile } = useMediaQueries();

  const match = useMatch('/crm/:lastPart');
  const tabValue = match?.params.lastPart;

  const { data: user, isLoading: isLoadingUser } = useUserQuery();

  const [selectedTabId, setSelectedTabId] = useState(tabValue ?? 'customers');

  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

  useEffect(() => {
    if (tabValue) setSelectedTabId(tabValue);
  }, [tabValue]);

  const getTabsData = useMemo(() => {
    return [
      {
        id: 'customers',
        label: intl.formatMessage({ id: 'crm.customers' }),
        component: <NomineeCustomers />,
        tabProps: {
          onClick: () => {
            navigate('/crm/customers');
          },
          value: 'customers',
        },
      },
      {
        id: 'investments',
        label: intl.formatMessage({
          id: 'crm.customerInvestmentsTitle',
        }),
        component: <NomineeInvestmentAttributions />,
        tabProps: {
          onClick: () => {
            navigate('/crm/investments');
          },
          value: 'investments',
        },
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setSelectedTabId(newValue);
  };

  const handleCloseSidePanel = () => {
    setIsSidePanelOpen(false);
  };

  const handleOpenSidePanel = () => {
    setIsSidePanelOpen(true);
  };

  if (isLoadingUser) return <Loader isLoading={isLoadingUser} />;

  return (
    <Container>
      <StyledHeaderContainer>
        <Header
          user={user}
          title={{
            name: intl.formatMessage({ id: 'menu.crm' }),
            to: '/crm',
          }}
        />
      </StyledHeaderContainer>

      <Flex height='100%'>
        <Tabs
          variant='scrollable'
          allowScrollButtonsMobile
          tabItem={getTabsData}
          onChange={handleChange}
          value={selectedTabId}
          tabRightComponent={() =>
            selectedTabId === 'investments' ? (
              <Button onClick={handleOpenSidePanel}>
                <FormattedMessage
                  id={
                    !isMobile
                      ? 'crm.investments.createNewInvestment'
                      : 'crm.investments.newInvestment'
                  }
                />
              </Button>
            ) : (
              <></>
            )
          }
        />
      </Flex>

      <NewInvestmentPanel
        isOpen={isSidePanelOpen}
        onClose={handleCloseSidePanel}
      />
    </Container>
  );
};

export default Crm;
